module.exports = __webpack_public_path__ + "static/favicon-d2ba21ac824e2506ab07d9e8d706dd1d.ico";